import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FieldContainer = styled.div<{ isPermissions?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  ${({ isPermissions }) =>
    isPermissions &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
    `}
`;

const Buttons = styled.div<{ toCenter?: boolean }>`
  display: flex;
  gap: 2rem;

  margin-top: 3rem;
  align-self: ${({ toCenter }) => (toCenter ? 'center' : 'flex-end')};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
    min-width: 14rem;
    padding: 1rem 2rem 1rem 0;

    font-size: 1.6rem;

    color: ${pickColor('black')};
    font-family: 'LFT Zeno Condensed';
    text-transform: uppercase;
  }
`;

export { FieldContainer, Buttons, ContentContainer, Wrapper };
